module.exports = {
  admin: "cmsAdmin",
  user: "cmsUser",
};
